export const categories = [
    { name: 'Café da Manhã', slug: 'cafe-da-manha', description: 'Cestas tradicionais e deliciosas' },
    { name: 'Maternidade', slug: 'maternidade', description: 'Para celebrar as novas mamães' },
    { name: 'Românticas', slug: 'romanticas', description: 'Para surpreender quem você ama' },
    { name: 'Happy Hour', slug: 'happy-hour', description: 'Vinhos, queijos e celebração' },
    { name: 'Chá da Tarde', slug: 'cha-da-tarde', description: 'Para um fim de tarde especial' },
    { name: 'Datas Comemorativas', slug: 'datas-comemorativas', description: 'Para todos os momentos' }
];

export const products = [
    {
        id: "bandeja-elegance",
        name: "Bandeja Élégance",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 1448.00,
        price_display: "R$ 1.448,00",
        description: "Bandeja em MDF decorada e embalada com celofane cristal!",
        items: [
            "02 Tipos de frutas nobres", "Brioches Parisienses", "Croissants de presunto ou queijo",
            "Strudell de maçã", "Rosca de leite condensado", "Pão de leite (tipo Petropólis)", "Pãezinhos de ervas, tipo americano", "Pães vienenses com gotas de chocolate", "Queijadinha caramelizada",
            "Carolinas recheadas com doce de leite e cobertura de chocolate", "Empadinhas de frango", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Nutella", "Queijo Brie", "Patê de presunto", "Torradas da Bauducco", "Amandita", "Mix de Nuts Premium: castanhas, amendoas e nozes",
            "Chá de frutas vermelhas", "Café 'Capuccino'", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Geléia de frutas vermelhas", "Mel 'em blister'", "Açucar", "Trufas ou bombons 'Ferrero Rocher'", "Caneca em porcelana com o nome do presenteado"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/bandeja-elegance.jpeg`,
        optional: "Lindo vaso de orquídeas. + R$ 290,00"
    },
    {
        id: "bandeja-vip",
        name: "Bandeja VIP",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 980.00,
        price_display: "R$ 980,00",
        description: "Belíssima bandeja em MDF decorada e fechada com papel celofane cristal e laço especial.",
        items: [
            "03 Tipos de frutas", "Brioches Parisienses", "Croissants de presunto ou queijo",
            "Strudell de maçã", "Pães vienenses com gotas de chocolate", "Pão de leite (tipo Petropólis)", "Queijadinha caramelizada", "Empadinhas de frango", "Rosca de leite condensado",
            "Carolinas recheadas com doce de leite e cobertura de chocolate", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Torradas especiais da Bauducco",
            "Geléia de frutas vermelhas", "Mel 'em blister'", "Água de côco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Iogurte", "Chá de frutas vermelhas", "Açucar", "Café 'Capuccino'", "Queijo em pasta (Polenguinho)", "Trufas finas em graciosa caixinha", "Caneca em porcelana personalizada", "Coração de chocolate recheado com coraçõezinhos de chocolate", "Cartão para dedicatória"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/bandeja-vip.jpeg`,
        optional: "Lindo vaso de orquídeas. + R$ 290,00"
    },
    {
        id: "bandeja-prime",
        name: "Bandeja Prime",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 809.00,
        price_display: "R$ 809,00",
        description: "Linda bandeja em MDF decorada e fechada com papel celofane cristal e laço especial.",
        items: [
            "03 Tipos de frutas", "Brioches Parisienses", "Croissants de presunto ou queijo",
            "Strudell de maçã", "Pães vienenses com gotas de chocolate", "Pão de leite (tipo Petropólis)", "Queijadinha caramelizada", "Empadinhas de frango", "Rosca de leite condensado",
            "Carolinas recheadas com doce de leite e cobertura de chocolate", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Iogurte", "Chá de frutas vermelhas", "Açucar", "Café 'Capuccino'", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado",
            "Geléia de frutas vermelhas", "Mel 'em blister'", "Queijo em pasta (Polenguinho)", "Trufas em caixa decorada", "Caneca em porcelana personalizada"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/bandeja-prime.jpeg`,
        optional: "Coração de chocolate recheado com coraçõezinhos de chocolate. + R$ 90,00"
    },
    {
        id: "cesta-splendida",
        name: "Cesta Splêndida",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 1520.00,
        price_display: "R$ 1.520,00",
        description: "Linda Cesta em vime, finamente ornamentada e embalada em celofane cristal e fitas em voil.",
        items: [
            "Garrafa de champagne Veuve Clicquot Ponsardin de 750 ml", "02 taças de cristal", "Mix de nuts (amêndoas, castanhas e pistaches)", "Patê Salman Gensen's", "Pacote de torradas para canapé", "Caixa de bombons Ferrero Rocher ou caixa com trufas finas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-splendida.png`,
    },
    {
        id: "cesta-black-tie",
        name: "Cesta Black Tie",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 620.00,
        price_display: "R$ 620,00",
        description: "Sofisticado arranjo em caixa de madeira, embalada com celofane cristal.",
        items: [
            "Garrafa de Moët & Chandon", "Mix de nuts contendo: Pistache, castanhas de caju, amendoim japonês e uvas passas", "Bombons Ferrero Rocher ou trufas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-black-tie.png`,
    },
    {
        id: "cesta-executiva-top",
        name: "Cesta Executiva TOP",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 593.00,
        price_display: "R$ 593,00",
        description: "Belíssima caixa cartonada em \"black\", arrematada com laços de gorgurão.",
        items: [
            "Garrafa de Whisky Ballantine's Finest 1L ou Garrafa de Whisky Red Label 1L ou Garrafa de Whisky 'White Horse' 1L", "18 bombons Ferrero Rocher"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-executiva-top.png`,
    },
    {
        id: "cafe-presente",
        name: "Cesta Café Presente",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 710.00,
        price_display: "R$ 710,00",
        description: "Linda caixa em MDF, peça de multi-uso, embalada em celofane e fechada com laços fartos e bem acabados.",
        items: [
            "02 Tipos de frutas", "Brioches Parisienses", "Croissants de presunto ou queijo",
            "Strudell de maçã", "Rosca de leite condensado", "Pão de leite (tipo Petropólis)", "Pãezinhos de ervas, tipo americano", "Pães vienenses com gotas de chocolate", "Queijadinha caramelizada",
            "Carolinas recheadas com doce de leite e cobertura de chocolate", "Empadinhas de frango", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Iogurte", "Chá de frutas vermelhas", "Café 'Capuccino'", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Geléia 'em blister'", "Mel 'em blister'", "Açucar", "Queijo em pasta (Polenguinho)", "Trufas em caixa ornamentada", "Caneca em porcelana com o nome do presenteado", "Carta para dedicatória"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-presente.png`,
    },
    {
        id: "cesta-cafe-manha-carolina",
        name: "Cesta Café da Manhã Carolina",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 566.00,
        price_display: "R$ 566,00",
        description: "Cesta em MDF, medindo 36x26cm, forrada e embalada com papel celofane cristal e arrematada com belo laço de fitas.",
        items: [
            "Lindo coração de chocolate", "Caneca de porcelana personalizada", "02 Tipos de frutas", "Pão de leite (tipo Petropólis)", "Croissants de presunto ou queijo", "Strudell de maçã", "Pães vienenses com gotas de chocolate", "Empadinhas de frango", "Queijadinha caramelizada", "Carolinas recheadas com doce de leite e cobertura de chocolate", "Brioches tipo americano",
            "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Iogurte", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Chá de frutas vermelhas", "Café 'Capuccino'", "Geléia 'em blister'", "Açucar", "Queijo em pasta (Polenguinho)", "Trufas em caixas arrematada com fitas",
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-carolina.jpeg`,
    },
    {
        id: "cesta-cafe-manha-1",
        name: "Cesta Café da Manhã I",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 395.00,
        price_display: "R$ 395,00",
        description: "Cesta em MDF, medindo 36x26cm, forrada e embalada com papel celofane cristal e arrematada com belo laço de fitas.",
        items: [
            "02 Tipos de frutas", "Pão de leite (tipo Petropólis)", "Croissants de presunto ou queijo", "Strudell de maçã", "Pães vienenses com gotas de chocolate", "Empadinhas de frango", "Queijadinha caramelizada", "Carolinas recheadas com doce de leite e cobertura de chocolate", "Brioches tipo americano",
            "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Iogurte", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Chá de frutas vermelhas", "Café 'Capuccino'", "Geléia 'em blister'", "Açucar", "Queijo em pasta (Polenguinho)", "Trufas em caixas arrematada com fitas",
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-1.jpeg`,
    },
    {
        id: "cesta-cafe-manha-2",
        name: "Cesta Café da Manhã II",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 350.00,
        price_display: "R$ 350,00",
        description: "Cesta em MDF, medindo 34x25cm, forrada e embalada com papel celofane cristal e arrematada com belo laço de fitas.",
        items: [
            "02 Tipos de frutas", "Pão de leite (tipo Petropólis)", "Croissants de presunto ou queijo", "Strudell de maçã", "Pães vienenses com gotas de chocolate", "Rosca de leite condensado", "Pãezinhos de ervas recheado com peito de peru", "Carolinas recheadas com doce de leite e cobertura de chocolate", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Leite achocolatado", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Iogurte", "Chá de frutas vermelhas", "Café 'Capuccino'", "02 tipos de geléia de frutas vermelhas", "Mel 'em blister'", "Açucar", "Queijo em pasta (Polenguinho)", "01 caixa com trufas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-2.jpeg`,
    },
    {
        id: "cesta-cafe-manha-3",
        name: "Cesta Café da Manhã III",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 298.00,
        price_display: "R$ 298,00",
        description: "Cesta em MDF, medindo 32x24cm, forrada e embalada com papel celofane cristal e arrematada com belo laço de fitas.",
        items: [
            "02 Tipos de frutas", "Pão de leite (tipo Petropólis)", "Croissants de presunto ou queijo", "Rosca de leite condensado", "Pãezinhos de ervas", "Carolinas recheadas com doce de leite e cobertura de chocolate", "Bolo caseiro (de côco ou chocolate)", "Biscoitos finos artesanais", "Torradas especiais da Bauducco", "Suco de frutas (embalagem Tetra Pack)", "Leite achocolatado", "Iogurte", "Chá de frutas vermelhas", "Café 'Capuccino'", "02 tipos de geléia", "Mel 'em blister'", "Açucar", "Queijo em pasta (Polenguinho)"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-3.jpeg`,
    },
    {
        id: "cesta-corporativa-lilli",
        name: "Cesta Corporativa Lilli",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 249.00,
        price_display: "R$ 249,00",
        description: "Cesta em craft cartonada, medindo 30x30cm, embalada e arrematada com belo laço de fitas.",
        items: [
            "Pães vienenses com gotas de chocolate", "Rosca de leite condensado", "Pãezinhos de ervas ou pão de leite (tipo Petropólis)", "01 fruta", "Bolo caseiro (de côco ou chocolate)", "01 pão de +- 200gr de biscoitos finos", "Suco", "Todinho", "02 tipos de geléia", "Queijo em pasta (Polenguinho)", "Mel 'em blister'", "Torradas da Bauducco"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/corporativa-lilli.jpeg`,
    },
    {
        id: "cesta-infantil",
        name: "Cesta Infantil",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 386.00,
        price_display: "R$ 386,00",
        description: "Cesta rústica de bamboo ou palhinha em \"Tresset\", forrada e embalada com celofane especial e arrematada por uma linda guirlanda de balas.",
        items: [
            "02 tipos de frutas", "Bolo de chocolate com cobertura de brigadeiro ou bolo de côco", "Pacote de biscoitos recheados", "Pacote de biscoitos tipo Waffer", "Pacote de pães de queijo", "Pacote de biscoitos caseiros tipo petit-four", "Pacote de pães de mel ou carolinas recheadas com doce de leite e cobertas com chocolate", "Pacote de batatas", "Coca-Cola ou suco de frutas", "02 pacotes de torradas", "02 geleias de frutas vermelhas em Blister", "02 mel em Blister", "Iogurte de frutas vermelhas", "Achocolatado"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-infantil.jpeg`,
    },
    {
        id: "cesta-maternidade",
        name: "Cesta Maternidade",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 458.00,
        price_display: "R$ 458,00",
        description: "Graciosa cesta de palhinha em \"Tresset\", forrada e embalada com celofane cristal decorado com corações e fitas.",
        items: [
            "02 tipos de frutas", "Brioches Parisienses", "Croissants de queijo ou de presunto", "Strudell de maçã", "Pão de leite, tipo Petrópolis", "Pães de ervas, tipo americano", "Pães vienenses com gotas de chocolate", "Bolo caseiro, de chocolate ou de côco", "Biscoitos finos artesanais", "Leite achocolatado", "Torradas especiais da 'Bauducco'", "Suco de frutas em embalagem 'Tetra Pack'", "Iogurte", "Chá de frutas vermelhas", "Café 'Capuccino'", "Geleias de frutas vermelhas", "Açúcar", "Mel em Blister", "Queijo em pasta (Polenguinho)", "Caixa de trufas", "Sapatinho ou pantufas para o bebê"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-maternidade.jpeg`,
    },
    {
        id: "cesta-cha-especial",
        name: "Cesta de Chá Especial",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 440.00,
        price_display: "R$ 440,00",
        description: "Cesta decorada com flores, embalada em papel celofane cristal e arrematada com fitas.",
        items: [
            "02 tipos de frutas", "Biscoitos finos artesanais", "Bolo de coco ou de chocolate (caseiro)", "Carolinas recheadas com doce de leite e cobertura de chocolate", "Strudell de maçã", "Rosca de leite condensado", "Brioches Parisienses", "Pãezinhos Vienenses com gotas de chocolate", "Croissants de queijo ou presunto", "Pãozinho de ervas recheado com peito de peru", "Suco de frutas (embalagem Tetra Pack)", "Água de côco", "Leite achocolatado", "Chá de frutas vermelhas", "Açúcar em pacotinho", "Café 'Capuccino'", "02 tipos de geleias em Blister", "Torradas especiais da 'Bauducco'", "Mel em Blister", "Queijo em pasta (Polenguinho)", "Caixa de trufas finas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-cha-especial.jpeg`,
    },
    {
        id: "cesta-chocolatra",
        name: "Cesta Chocólatra",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 296.00,
        price_display: "R$ 296,00",
        description: "Cesta modelo canoa, em vime ou palhinha, finamente embalada em papel celofane cristal e arrematada com laços de cetim.",
        items: [
            "105 grs. de bombons Sonho de Valsa", "Barra de chocolate branco Galak", "Barra de chocolate Diamante Negro", "03 barras de chocolate Garoto de 25 grs. cada nos sabores: chocolate ao leite com amêndoas e uvas passas, chocolate branco com cereais, crocante e uvas passas, e chocolate ao leite com avelã", "Super barra de chocolate ao leite da Lacta de 170 grs.", "Super barra de chocolate branco com biscoito sabor chocolate da Hershey's de 130 grs.", "Barra de chocolate com recheio de morango Sensação da Nestlé de 38 grs.", "Barra de chocolate Prestígio da Nestlé de 33 grs.", "Barra de chocolate Chokito da Nestlé de 32 grs.", "Barra de chocolate com amendoim Charge da Nestlé de 40 grs.", "Embalagem de M&M's de 49 grs.", "Bolo de chocolate com cobertura de granulado", "Twix - biscoito e caramelo coberto com chocolate de 45 grs.", "Frasco de achocolatado", "Caixa de trufas (com 2 unidades)"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-chocolatra.png`,
        optional: "Coração de chocolate recheado com coraçõezinhos de chocolate. + R$ 90,00"
    },
    {
        id: "cesta-cafe-6-pessoas",
        name: "Cesta Café da Manhã p/ 06 pessoas",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 850.00,
        price_display: "R$ 850,00",
        description: "Cesta de vine, forrada com guarnição descartável e embalada em papel celofane especial e fechada com um belo laço.",
        items: [
            "Uvas para ornamentação", "03 pacotes de brioches de côco", "03 pacotes de croissants de presunto ou queijo", "03 pacotes de pãezinhos de ervas, tipo americano", "03 pacotes de empadinhas de frango", "03 pacotes de pães vienenses com gotas de chocolate", "03 pacotes de carolinas de doce de leite com cobertura de chocolate", "03 bolos variados", "06 sucos de frutas (embalagem Tetra Pack)", "06 leites achocolatados (embalagem Tetra Pack)", "06 pacotes de torradas Bauducco", "06 geleias de frutas (sabores diversos)", "06 polenguinhos", "06 cafés 'cappuccino'", "06 pacotes de açucar", "06 sachês de chá de frutas vermelhas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-06-pessoas.png`,
    },
    {
        id: "cesta-cafe-10-pessoas",
        name: "Cesta Café da Manhã p/ 10 pessoas",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 440.00,
        price_display: "R$ 440,00",
        description: "Cesta de vine, forrada com guarnição descartável e embalada em papel celofane especial e fechada com um belo laço.",
        items: [
            "Uvas para ornamentação", "05 pacotes de brioches de côco", "05 pacotes de croissants de presunto ou queijo", "05 pacotes de pãezinhos de ervas, tipo americano", "05 pacotes de empadinhas de frango", "05 pacotes de pães vienenses com gotas de chocolate", "05 pacotes de queijadinha caramelizada", "05 pacotes de carolinas de doce de leite com cobertura de chocolate", "05 bolos variados", "10 sucos de frutas (embalagem Tetra Pack)", "10 leites achocolatados (embalagem Tetra Pack)", "10 pacotes de torradas Bauducco", "10 geleias de frutas (sabores diversos)", "10 mel (em blister)", "10 polenguinhos", "10 cafés 'cappuccino'", "10 sachês de chá de frutas vermelhas", "10 pacotes de açucar"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cafe-da-manha-10-pessoas.jpeg`,
    }, {
        id: "cesta-coisas-de-minas",
        name: "Cesta de Coisas de Minas",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 476.00,
        price_display: "R$ 476,00",
        description: "Cesta em M.D.F., com forração especial e decoração típica, embalada em papel celofane especial e arrematada com fitas de cetim.",
        items: [
            "03 tipos de frutas cristalizadas", "Broa de fubá", "Requeijão de rapa ou queijo de Minas", "Biscoitos de polvilho", "Doce de leite puro ou com coco", "Biscoitos caseiros de limão", "Broinha de canjica ou carolinas recheadas com doce de leite", "Doce de laranja em compota ou doce de mamão em compota", "Torradas levemente salgadas da Bauducco", "Geleia de frutas", "Canudinhos de doce de leite", "Pé de moleque", "Rapadura"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-coisas-de-minas.png`,
    },
    {
        id: "cesta-diet-light",
        name: "Cesta Diet/Light",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 440.00,
        price_display: "R$ 440,00",
        description: "Cesta de MDF recortada à laser, forrada e embalada com celofane cristal.",
        items: ["03 tipos de frutas", "Todinho light ou lata de água tônica", "Água de côco", "02 sanduiches de pães integrais com pate light", "Pacote de cookies ou biscoitos recheados lighy/diet", "Pacote de Wafer Diet", "Polenguinho light", "Sache de chá de frutas vermelhas", "Envelope de adoçante", "Sache de 'capuccino' diet", "Pacoquinha diet", "Pé-de-moloque diet", "Barra de chocolate diet", "Cartão para dedicatória"],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-light.jpeg`,
    },
    {
        id: "cesta-frutas-e-flores",
        name: "Cesta Frutas e Flores",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 368.00,
        price_display: "A partir de R$ 368,00",
        description: "Belíssima bandeja (a de tamanho G, vai com flores) formando um \"show\" de cores e sabores, embalada e arrematada com fitas.",
        items: [
            "São servidos diversos e variados tipos de saborosas frutas tropicais."
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-frutas-e-flores.jpeg`,
    },
    {
        id: "cesta-frios-queijos-e-vinho",
        name: "Cesta de Frios Queijos e Vinho",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 480.00,
        price_display: "R$ 480,00",
        description: "Linda caixa em MDF, decorada e embalada com celofane cristal especial.",
        items: [
            "Garrafa de vinho (do Cone Sul)", "03 tipos de frios: LoCanadense,mbinho  Salaminho Italiano e Blanquet de Peru", "02 tipos de queijos: Provolone e Queijo Prato", "Estes frios e queijos são dispostos e decorados em pratinho cristal descartável", "Castanhas de caju ou amendoim japonês", "Azeitonas", "Patê de presunto", "03 pacotes de torradas levemente salgadas da Bauducco", "Caixa de bombons ou trufas"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-frios-queijos-e-vinho.jpeg`,
    },
    {
        id: "cesta-beer",
        name: "Cesta Beer",
        category: "Café da Manhã",
        category_slug: "cafe-da-manha",
        price: 480.00,
        price_display: "R$ 480,00",
        description: "Cesta em MDF, embalada com celofane cristal.",
        items: [
            "06 tipos de cervejas em lata", "Lombo canadense", "Blanquet de peru", "Salaminho italiano", "Queijo Gouda ou Provolone", "Queijo Prato", "Azeitonas e cerejas", "Castanhas de caju ou amendoim japonês", "Completando a decoração, uvas", "Estes frios e queijos são dispostos e decorados em pratinhos descartáveis com cerejas, arranjados em forma de leque, produzindo um agradável visual"
        ],
        image: `${process.env.PUBLIC_URL}/images/products/cesta-beer.jpeg`,
    },
];